import React, {PropsWithChildren, ReactElement} from 'react';
import { ExternalLink } from '@mo/external-link';
import './footer.scss';

const PrivacyPolicy: React.FunctionComponent<PropsWithChildren<Record<never,never>>> = ({ children = 'Privacy Policy' }: PropsWithChildren<Record<never,never>>): ReactElement => (
        <ExternalLink
            href='https://smart.motabilityoperations.co.uk/Privacy'
            analyticsTag='privacy-policy'
            withoutIcon
        >
            {children}
        </ExternalLink>
    );

export default PrivacyPolicy;
